import UpdatePricesPage from "../views/UpdatePrices";
import PricesSection from "../views/PricesSection/PricesSection";
import { PricesLog } from "../views/PricesLog/PricesLog";

import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

export const pricesRoutes = [
  {
    collapse: true,
    name: "Precios",
    icon: AttachMoneyIcon,
    state: "priceSection",
    inSidebar: true,
    isProtected: true,
    rule: "STATION_PRICES",
    views: [
      {
        path: "/actualizacion_precios_planta",
        name: "Act. de Precios Planta",
        mini: "ACT",
        component: UpdatePricesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "UPDATE_STATION_PRICE",
      },

      {
        path: "/precios",
        name: "Precios Planta",
        mini: "PRE",
        component: PricesSection,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "STATION_PRICES",
      },
      {
        path: "/precios-log",
        name: "Registro de precios enviados",
        mini: "PRE",
        component: PricesLog,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: "STATION_PRICES",
      },
    ],
  },
] 